export const FEATURE_FLAGS_AUTH_FEATURE_KEY = 'featureFlagsAuth';
